import { render, staticRenderFns } from "./Res.vue?vue&type=template&id=bda705de&scoped=true"
import script from "./Res.vue?vue&type=script&lang=js"
export * from "./Res.vue?vue&type=script&lang=js"
import style0 from "./Res.vue?vue&type=style&index=0&id=bda705de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda705de",
  null
  
)

export default component.exports